import React from 'react';
import CollectionCard from '../CollectionCard';
import './styles.scss';

const CollectionsList = ({
  setSelectedCollection,
  loading,
  collections,
  }) => {

  return (
    <div className="clients-v2-collections--list">
      <div className="clients-v2-collections--list-items">
        {loading && <div className="clients-v2-collections--list-subtitle">Loading...</div>}

        {!loading && collections?.length === 0 && (
          <div className="clients-v2-collections--list-subtitle">No Collections</div>
        )}

        {!loading &&
          collections?.length > 0 &&
          collections.map(item => (
            <CollectionCard key={item.id} collection={item} onClick={() => {
              setSelectedCollection(item);
            }} />
          ))}
      </div>
    </div>
  );
};

export default CollectionsList;
